(function documentControllerDefinition() {
    'use strict';

    angular.module('Migrator')
        .controller('MigratorDetailController', [
            '$scope', '$translate', '$state', 'errorsExtend', '$stateParams', 'migratorService',
        function migratorDetailController($scope, $translate, $state, errors, $stateParams, migratorService) {

            $scope.cancel = function () {
                $state.go('migrator-find');
            };

            $scope.load = function () {

                migratorService.getById($stateParams.id).then(function (result) {
                    $scope.migrator = result;
                }, function (error) {
                    errors.showError(error);
                    $scope.cancel();
                });
            };

            $scope.view = function (migrator) {
                $state.go('migrator-batch-detail', { id: $stateParams.id, nro: migrator.batch });
            };


            $scope.load();
        }
        ]);
})();